module.exports = __webpack_public_path__ + "static/36th-42be8bf27d0487a730311ad98b44e41e.png";